import React from "react"
import Dot from "./Dot"


export default function SecondFace(){
    return(
        <div className="dice second-face">
            <Dot />
            <Dot />
        </div>
    )
}